import style from "./style.scss";

import { Fragment } from "preact";
import Link from "../../../components/link";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import BigText from "../../../components/big-text";
import BigBlock from "../../../components/big-block";
import Ligature from "../../../components/ligature";
import NoWrap from "../../../components/no-wrap";
import CandidateItem from "../../../components/candidate-item";
import Accordion from "../../../components/accordion";
import VoteItems from "../../../components/vote-items";
import namedRoutes from "../../../settings/routes";

const pageTitle = "2025 - Klahanie.info";

const Home = () => (
  <div>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Restore your{" "}
        </span>
        <Ligature>Voting Rights</Ligature>
      </h1>
      <h2>
        <span>
          <NoWrap>"Your Voice,</NoWrap> <NoWrap>Our Promise"</NoWrap>
        </span>
      </h2>
    </Hero>
    <Editorial>
      <Center>
        <BigText>
          <Ligature>In</Ligature> 2023, behind closed doors, the Klahanie HOA
          Board revised our bylaws, seizing authority to spend millions without
          homeowner consent.
        </BigText>
      </Center>
      <Center>
        <div style="text-align: center;">
          <BigText uppercase>
            <NoWrap>Board now</NoWrap> <NoWrap>plans to spend</NoWrap>
          </BigText>
        </div>
        <BigBlock uppercase>
          <NoWrap>$9,000,000</NoWrap>{" "}
          <span style="font-size: 0.35em; font-weight: 900; display: inline-block; vertical-align: middle; margin-top: -0.3em;">
            to
          </span>{" "}
          <NoWrap>$12,000,000 +</NoWrap>
        </BigBlock>
      </Center>
      <Center>
        <h2 id="endorsed">Restore Your Voting Rights by Electing</h2>
        <p>
          Seven candidates are vying for three open positions, each with very
          different priorities and backgrounds. Three candidates,{" "}
          <strong>
            <Link href={namedRoutes.archive2025.jimCline}>Jim Cline</Link>
          </strong>
          ,{" "}
          <strong>
            <Link href={namedRoutes.archive2025.ericaFloden}>Erica Floden</Link>
          </strong>
          , and{" "}
          <strong>
            <Link href={namedRoutes.archive2025.rachelLong}>Rachel Long</Link>
          </strong>
          , will{" "}
          <strong>
            prioritize Klahanie homeowner input over their own interests
          </strong>
          .
        </p>
        <ul class={style.candidatesList}>
          <CandidateItem
            img="/images/candidates/jim-cline.jpg"
            name="Jim Cline"
            since="2008"
            email="undihrs@gmail.com"
            url={namedRoutes.archive2025.jimCline}
          />
          <CandidateItem
            img="/images/candidates/erica-floden.jpg"
            name="Erica Floden"
            since="2008"
            email="efloden@hotmail.com"
            url={namedRoutes.archive2025.ericaFloden}
          />
          <CandidateItem
            img="/images/candidates/rachel-long.jpg"
            name="Rachel Long"
            since="1991"
            email="Rachel4Klahanie@gmail.com"
            url={namedRoutes.archive2025.rachelLong}
          />
        </ul>
        <p>
          Please feel free to reach out to any of these candidates with any
          questions you may have.
        </p>
        {/* <p>
          Your vote is vital to ensure our community is led by individuals who
          listen to your concerns, prioritize your needs, and manage our
          resources responsibly.
        </p> */}
      </Center>
      <Center>
        <h2>Concerns About Past Board Decisions</h2>
        <p>
          Residents have expressed frustration with the Board’s{" "}
          <strong>lack of transparency</strong> and inclusivity regarding the
          proposal to spend <strong>$9-12+ million</strong> to build an 8-lane
          pool, community room, and HOA office (aka the Klahanie Community
          Center project).
        </p>
        <ul>
          <li>
            <strong>Bylaws Changed:</strong> In 2023, the Board revised the
            bylaws without a homeowner vote, in a private executive meeting,
            enabling it to make substantial financial decisions without the need
            for homeowner approval or oversight. The detail of the changes were
            not communicated to homeowners. (
            <Link href="#bylaw-change">see details below</Link>)
          </li>
          <li>
            <strong>Higher Dues:</strong> A loan of this magnitude, plus
            interest and increased operating costs, will lead to higher HOA
            dues, with no guarantee of increased property value.
          </li>
          <li>
            <strong>Board Voted "No" to Survey Homeowners:</strong> In December
            2024, the current Board denied a motion to conduct a statistically
            valid survey after project costs and related expenses have been
            determined. <strong>NOTE:</strong> <em>Jennifer S.</em>, current
            board member and candidate running for reelection voted NO on this
            motion.
          </li>
          <li>
            <strong>Lack of Transparency:</strong> Despite repeated requests,{" "}
            <strong>no proven justification</strong> or cost breakdown has been
            provided for their proposal to spend $9-12M+ for the pool, office, &
            community center project.
          </li>
        </ul>
      </Center>
      <Center>
        <h2 id="bylaw-change">2023 Bylaw Change Details</h2>
        <p>
          <strong>
            In 2023, behind closed doors, the HOA Board revised our bylaws,
            seizing authority to spend millions without homeowner consent.
          </strong>
        </p>
        <p>
          <strong>NOTE:</strong> Two current running board candidates were on
          the HOA board at the time of this bylaw change. <em>Don S.</em>, was
          HOA Board President and <em>Jennifer S.</em>, was HOA Board Secretary.
        </p>
        <h3>Prior to 2023</h3>
        <blockquote>
          <strong style="font-weight: 700; margin-right: 6px;">4.6.17</strong>{" "}
          Borrow money and pledge or assign its right to future income in the
          form of assessments related thereto; however{" "}
          <strong>
            the Board shall not have power to borrow money on behalf of the
            Association
          </strong>{" "}
          or pledge or assign its right to future income in excess of ten
          percent (10%) of the asset value of the Association unless first
          specifically <strong>authorized by a majority vote</strong> (51%
          affirmative approval) of the total votes of the Association.
        </blockquote>

        <h3>Current</h3>
        <blockquote>
          <strong style="font-weight: 700; margin-right: 6px;">4.6.17</strong>{" "}
          Borrow funds from banks, other financial institutions, lenders,
          vendors, and/or contractors and to assign or pledge common funds of
          the Association, including its right to future income and the right to
          receive Assessments, to secure any such loans;
        </blockquote>

        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.klahanie.com/overview"
        >
          View current bylaws and other related documents
        </Link>
      </Center>
      <Center>
        <h2>When Elected, They Will Work To</h2>
        <ul>
          <li>
            <strong>Restore voting rights</strong> for homeowners on large
            financial decisions (bylaw 4.6.17).
          </li>
          <li>
            <strong>
              Pause the pool, office, and community center project
            </strong>{" "}
            to consider all options, assess financial impact, share the results
            with homeowners, and carefully evaluate homeowner feedback.
          </li>
          <li>
            <strong>Maintain or replace office, pools,</strong> etc. in a
            financially responsible way based on homeowner input.
          </li>
          <li>
            <strong>Engage residents</strong> and vote on key projects based on
            the majority of homeowners’ interests.
          </li>
          <li>
            <strong>Use HOA fees responsibly and transparently</strong> for the
            long-term financial health of Klahanie.
          </li>
        </ul>
        {/* <span style="display: block; margin-top: 0.2em; padding: 0.1em 0.5em; color: #1c3666; background-color: #fff;"></span> */}

        <div style="width: 85%; margin: auto;">
          <BigBlock>
            <NoWrap>"Your Voice,</NoWrap> <NoWrap>Our Promise"</NoWrap>
          </BigBlock>
        </div>
      </Center>
      <Center>
        <h2 id="how-to-vote">How to Vote</h2>
        <p>
          You should have already received your voting information. If not,
          please see details below. Voting ends March 7<sup>th</sup> at 11:59
          PM.
        </p>

        <h3>Online Ballot</h3>
        <p>
          If you received an email from <em>Vote HOA Now</em>, use your personal
          registration code on the{" "}
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://klahanie.ivotehoa.com/register"
          >
            community voting site
          </Link>
          . You might need to check your spam folder.
        </p>

        <p>
          If you didn't receive a personal registration code, there are two
          primary options:
          <ul>
            <li>
              <strong>Pick up a code in person:</strong> You can pick up the
              code in person at the Klahanie Association Office. Remember to
              bring your identification so your address and identity can be
              verified. See the{" "}
              <Link
                target="_blank"
                rel="noreferrer"
                href="https://www.klahanie.com/contact"
              >
                office hours
              </Link>{" "}
              page for scheduled hours, however this can be impacted by the
              school's snow schedule in winter.
            </li>
            <li>
              <strong>Request a code via email:</strong> If you cannot make it
              into the office during business hours, you can email a picture of
              your ID to{" "}
              <Link rel="noreferrer" href="mailto:info@klahanie.com">
                info@klahanie.com
              </Link>
              . Once staff has verified your identity and residency, they will
              email you your voting code.
            </li>
          </ul>
        </p>

        <p>
          There is a form on the community voting site's{" "}
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://klahanie.ivotehoa.com/contact"
          >
            contact page
          </Link>
          , however they still require you to go in person or submit your ID via
          email to receive a code so this seems like an extra unnecessary step.
        </p>

        <h3>Paper Ballot</h3>
        <p>
          Fill out a paper ballot or proxy at the Klahanie Association Office or
          request a paper ballot be sent to your home address. All paper ballots
          and proxies must be turned in at the Klahanie Association Office by
          March 7<sup>th</sup> at 4:00 PM. Remember to bring your identification
          so your address and identity can be verified when you arrive. See the{" "}
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://www.klahanie.com/contact"
          >
            office hours
          </Link>{" "}
          page for scheduled hours, however this can be impacted by the school's
          snow schedule in winter.
        </p>
      </Center>
      <Center>
        <h2 id="ballot-items">Ballot Items</h2>
        <p>Items highlighted in green are supported by our candidates:</p>
        <Accordion
          items={[
            {
              question: "Make a choice",
              answer: (
                <VoteItems
                  items={[
                    {
                      selected: true,
                      text: "Vote on 2 items and for up to 3 candidates (choices will be on the next screens)",
                    },
                    { text: "Submit for quorum purposes only" },
                  ]}
                />
              ),
            },
            {
              question: "2024 Annual Meeting Minutes",
              answer: (
                <Fragment>
                  <p>
                    View page 7 of the attachment for the 2024 Annual Meeting
                    Minutes.{" "}
                    <Link
                      target="_blank"
                      href="/downloads/2024-annual-meeting-minutes.pdf"
                    >
                      View meeting minutes
                    </Link>
                  </p>
                  <VoteItems
                    items={[
                      {
                        text: "Yes, I approve the 2024 Annual Meeting Minutes",
                      },
                      {
                        text: "No, I do not approve the 2024 Annual Meeting Minutes",
                      },
                    ]}
                  />
                </Fragment>
              ),
            },
            {
              question: "Revenue Ruling 70-604 of Excess Income",
              answer: (
                <Fragment>
                  <p>
                    Motion to adopt the Resolution for Revenue Ruling 70-604
                    Election-Excess Income Applied to the Following Year’s
                    Assessment, as required by the Internal Revenue Service
                    (IRS). The purpose of revenue ruling 70-604 is to allow a
                    homeowner’s association that has excess member income in a
                    given tax year to either refund that excess to the members
                    or roll it over to the next tax year to avoid taxation of
                    the “inadvertent” excess member income.{" "}
                    <Link
                      target="_blank"
                      rel="noreferrer"
                      href="https://hoatax.com/guide-revenue-ruling-70-604/"
                    >
                      Learn more
                    </Link>
                  </p>
                  <VoteItems
                    items={[
                      {
                        selected: true,
                        text: "Yes, I approve the Revenue Ruling 70-604 of Excess Income",
                      },
                      {
                        text: "No, I do not approve the Revenue Ruling 70-604 of Excess Income",
                      },
                    ]}
                  />
                </Fragment>
              ),
            },
            {
              question: "Candidates",
              answer: (
                <Fragment>
                  <p>Select up to 3:</p>
                  <VoteItems
                    items={[
                      { text: "Don Stephanian" },
                      {
                        selected: true,
                        text: (
                          <Link href={namedRoutes.archive2025.ericaFloden}>
                            Erica Floden
                          </Link>
                        ),
                      },
                      { text: "Jennifer Shepherd" },
                      {
                        selected: true,
                        text: (
                          <Link href={namedRoutes.archive2025.jimCline}>
                            Jim Cline
                          </Link>
                        ),
                      },
                      { text: "Kim Wheelock" },
                      {
                        selected: true,
                        text: (
                          <Link href={namedRoutes.archive2025.rachelLong}>
                            Rachel Long
                          </Link>
                        ),
                      },
                      { text: "Scott Powell" },
                    ]}
                  />
                  <p>Write in another candidate...</p>
                </Fragment>
              ),
            },
          ]}
        />
        <ul class={style.buttonList}>
          <li>
            <Link
              class="button"
              target="_blank"
              rel="noreferrer"
              href="https://klahanie.ivotehoa.com/register"
            >
              Vote Online
            </Link>
          </li>
          <li>
            <Link
              class="button secondary"
              target="_blank"
              rel="noreferrer"
              href="https://www.klahanie.com/contact"
            >
              Contact HOA Office
            </Link>
          </li>
        </ul>
      </Center>
      <Center>
        <h2>Resources</h2>
        <ul>
          <li>
            <strong>
              <Link
                href="https://www.facebook.com/groups/618929933832686/"
                target="_blank"
                rel="noreferrer"
              >
                Klahanie Residents Facebook group
              </Link>
            </strong>{" "}
            - Have discussions on <strong>ALL things</strong> Klahanie.
          </li>
          <li>
            <strong>
              <Link
                href="https://klahanie.ivotehoa.com/register"
                target="_blank"
                rel="noreferrer"
              >
                Vote Online
              </Link>
            </strong>{" "}
            - via Vote HOA Now.
          </li>
          <li>
            <strong>
              <Link
                href="https://www.klahanie.com/"
                target="_blank"
                rel="noreferrer"
              >
                Klahanie HOA website
              </Link>
            </strong>{" "}
            - Homeowners Association.
          </li>
          <li>
            <strong>
              <Link
                href="https://www.klahanie.com/residentportal"
                target="_blank"
                rel="noreferrer"
              >
                Klahanie Resident Portal
              </Link>
            </strong>{" "}
            - HOA documents and other information.
          </li>
          <li>
            <strong>
              <Link
                href="https://www.klahanie.com/overview"
                target="_blank"
                rel="noreferrer"
              >
                View bylaws and related documents
              </Link>
            </strong>
          </li>
          <li>
            <strong>
              <Link href={namedRoutes.archive2025.downloads}>
                Download campaign assets
              </Link>
            </strong>
          </li>
        </ul>

        <h5 style="margin-top: 2em;">Check back for more updates</h5>
      </Center>
    </Editorial>
  </div>
);

export default Home;
